/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_2_LInputs */

const en_cp_fact_2_l = /** @type {(inputs: Cp_Fact_2_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per team per semester`)
};

const id_cp_fact_2_l = /** @type {(inputs: Cp_Fact_2_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per tim per semester`)
};

/**
* | output |
* | --- |
* | "per team per semester" |
*
* @param {Cp_Fact_2_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_2_l = /** @type {((inputs?: Cp_Fact_2_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_2_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_2_l(inputs)
	return en_cp_fact_2_l(inputs)
});